<template>
  <div v-if="payment && paypalData">
    <Card title="payment-type-card"> 
      <paypal-card-pay />
    </Card>
    <router-link :to="`/${payment.id}`" class="underline font-black text-14 text-white mt-24 mb-50 inline-block"> {{ $t("payment-code-goback") }}</router-link>
  </div>
</template>

<script>
import Card from '@/components/Card.vue'
import linkToPayData from '@/mixins/linkToPayData.js'
import PaypalCardPay from '@/components/PaypalCardPay'

export default {
  name: 'CardPay',
  components: {
    Card,
    PaypalCardPay
  },
  mixins: [linkToPayData]
}
</script>